<!--Header and subtitle-->
<div class="fdx-o-grid__row fdx-o-grid__row--center">
  <div class="fdx-o-grid__item--12@small-only fdx-u-align--center">
    
    <!-- Email Change Information Section -->
    <div class="fdx-u-mb--4">
      <h2 class="fdx-c-header fdx-c-header--h4 fdx-u-mb--3" id="title">
        {{ 'profileEdit.verifyEmail.title' | translate }}
      </h2>
    </div>

    <div class="fdx-u-align--center fdx-u-mb--7 fdx-u-ml--2 fdx-u-mr--2">

      <!-- innerHTML subtitle + icon inline (span is inline by default) -->
      <span class="fdx-u-font-size--h7 fdx-u-text--light"
            aria-live="assertive" aria-atomic="true"
            id="verifySubtitle" [innerHTML]="subTitleText">
      </span>
      <span class="fdx-u-ml--1"
            [attr.aria-label]="'profileEdit.verifyEmail.tooltipText' | translate"
            (mouseover)="questionMarkVisibility = true"
            (mouseout)="questionMarkVisibility = false">
        <ciam-icon [key]="'questionmark-circle'" [color]="'blue'"></ciam-icon>
      </span>

      <!-- Tooltip content shown on hover -->
      @if (questionMarkVisibility) {
        <div class="fdx-u-display--flex fdx-u-flex-justify-content--center fdx-u-ml--20">
          <div aria-live="assertive"
               class="fdx-c-tooltip__main"
               id="verify-tooltip-label"
               role="tooltip">
            <div class="fdx-c-tooltip__main__body fdx-u-align--left">
              {{ 'profileEdit.verifyEmail.tooltipText' | translate }}
            </div>
          </div>
        </div>
      }
    </div>
    
    <!--Adding the Form input fields containing the 6 digit verification code -->
    <div class="fdx-o-grid fdx-o-grid--max-width">
      <div class="fdx-o-grid__row fdx-o-grid__row--center">
        <div class="fdx-o-grid__item--6 fdx-u-align--left">
          <div class="fdx-u-display--flex fdx-u-flex-justify-content--center fdx-u-pb--4">
            <form [formGroup]="verificationCodeForm" [class.ng-submitted]="formSubmit">
              <div class="fdx-c-single-digits">
                <fieldset class="fdx-c-single-digits__fieldset">
                  <legend class="fdx-c-single-digits__legend">{{ 'enterPinPopup.enterCode' | translate }}</legend>
                  <div 
                    *ngFor="let digit of digits; let i = index;"
                    [class.fdx-c-single-digits__item--is-invalid]="((verificationCodeForm.controls[digit].invalid &&
                      (verificationCodeForm.controls[digit].dirty || verificationCodeForm.controls[digit].touched)) ||
                      (verificationCodeForm.controls[digit].invalid && formSubmit)) || digitsStatus[digit] || expiredAndIncorrectError"
                    class="fdx-c-single-digits__item">
                    <input type="number" autocomplete="one-time-code" min="0" id="input{{i+1}}" 
                      aria-label="Verification Code Digit {{i+1}}"
                      formControlName="{{digit}}" 
                      class="fdx-c-single-digits__item__input paddingWCiOS"
                      maxlength="1" size="1" contenteditable="true"
                      name="auth-token" inputmode="numeric" pattern="[0-9]*"
                      (keyup)="onValueChange($event, i)"
                      (click)="onClickEvent(i)"
                      (blur)="onBlurEvent(i)"
                      (keydown)="onKeyDown($event, i)"
                      (paste)="pasteValues($event)"
                      (input)="handleChange()">
                  </div>
                </fieldset>
              </div>
              
              <!-- Code validity message -->
              <p class="fdx-u-font-size--super-small fdx-u-text--light fdx-u-mb--2 fdx-u-mt--2 fdx-u-align--left">
                {{ 'profileEdit.verifyEmail.codeValidity' | translate }}
              </p>

              <div *ngIf="verificationCodeForm.invalid" class="fdx-c-form-message--error fdx-u-font-size--super-small fdx-u-mb--1"
                id="verificationFormInvalid">
                <div *ngIf="!expiredAndIncorrectError && toggleElement && (digitValidStatus
                  ||((verificationCodeForm.controls['digit1'].invalid && ( verificationCodeForm.controls['digit1'].dirty || verificationCodeForm.controls['digit1'].touched )) || (verificationCodeForm.controls['digit1'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit2'].invalid && ( verificationCodeForm.controls['digit2'].dirty || verificationCodeForm.controls['digit2'].touched )) || (verificationCodeForm.controls['digit2'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit3'].invalid && ( verificationCodeForm.controls['digit3'].dirty || verificationCodeForm.controls['digit3'].touched )) || (verificationCodeForm.controls['digit3'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit4'].invalid && ( verificationCodeForm.controls['digit4'].dirty || verificationCodeForm.controls['digit4'].touched )) || (verificationCodeForm.controls['digit4'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit5'].invalid && ( verificationCodeForm.controls['digit5'].dirty || verificationCodeForm.controls['digit5'].touched )) || (verificationCodeForm.controls['digit5'].invalid && formSubmit))
                  || ((verificationCodeForm.controls['digit6'].invalid && ( verificationCodeForm.controls['digit6'].dirty || verificationCodeForm.controls['digit6'].touched )) || (verificationCodeForm.controls['digit6'].invalid && formSubmit)))"
                     class="fdx-c-form-message fdx-c-form-message--error fdx-u-pl--0 fdx-u-pt--1"
                     role="alert">
                  <div class="fdx-u-mr--0">
                <div style="mask-position: center">
                  <ciam-icon [color]="'red'" [key]="'utility_cross-fat'"></ciam-icon>
                </div>
              </div>
                  {{ 'enterPinPopup.codeRequiredError' | translate }}
                </div>
              </div>
              
              <div *ngIf="expiredAndIncorrectError"
                class="fdx-c-form-message fdx-u-flex-align-items--start fdx-c-form-message--error fdx-u-mb--2 fdx-u-pl--0 fdx-u-pt--0 fdx-u-align--left"
                role="alert">
                <div class="fdx-c-form-message__icon fdx-c-icon">
                  <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                </div>
                {{ 'enterPinPopup.codeExpired' | translate }}
              </div>
              
              <div *ngIf="systemUnavailableError"
                class="fdx-c-form-message fdx-u-flex-align-items--start fdx-c-form-message--error fdx-u-mb--2 fdx-u-pl--0 fdx-u-pt--0 fdx-o-grid__item--11@large fdx-u-align--left"
                role="alert">
                <div class="fdx-c-form-message__icon fdx-c-icon">
                  <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                </div>
                {{ 'enterPinPopup.apiError' | translate }}
              </div>                  
            </form>
          </div>
        </div>
      </div>
    </div>
  
    <!-- submit button -->
    <div class="fdx-o-grid__item fdx-o-grid__item--12 fdx-u-align--center fdx-u-mb--3 fdx-u-mt--7">
      <button id="submit-btn" #submitBtn (click)="validatePin()"
      class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--responsive"
      aria-atomic="true" aria-live="assertive">
      {{ 'common.continue' | translate }}
      </button>
    </div>

  
  <!-- Request New code button -->
    <div class="fdx-u-align--center fdx-u-mb--6">
      <a tabindex="0" id="requestCode-btn" (click)="resendPin()"
        class="fdx-c-button fdx-c-button--suffix fdx-c-button--text fdx-c-button--responsive verify-action-link" aria-atomic="true"
        aria-live="assertive">{{ 'enterPinPopup.requestNewCode' | translate }}</a>
    </div>
  </div>
    <!-- Change Email link -->
  <div class="fdx-u-align--center">
    <button (click)="changeEmail()" [attr.aria-label]="'profileEdit.verifyEmail.changeEmail' | translate"
            class="fdx-c-button fdx-c-button--text fdx-u-mb--7 fdx-u-cursor--pointer verify-action-link"
            id="Change-emailLink"
            tabindex="0">
      {{ 'profileEdit.verifyEmail.changeEmail'| translate }}
    </button>
  </div>
</div>
